
import Vue, { nextTick } from 'vue';

export default Vue.extend({
  name: 'Modal',
  props: {
    /**
     * Used to manually show/hide the modal when the prop `alwaysInDOM` is set to `true`
     */
    showModal: {
      type: Boolean,
      default: false,
    },
    /**
     * If set to `true`, the modal will always be in the DOM for better crawling
     */
    alwaysInDOM: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: null,
      visible: false,
      // Starts disabled so SSR/static output renders the content in place instead of an empty portal-target
      disablePortal: true,
    };
  },
  mounted() {
    if (!this.alwaysInDOM) {
      this.openModal();
    }
    this.header = document.querySelector('header.grid-container');
    if (this.header) {
      this.setPadding(this.header);
    }
    this.disablePortal = false;
    // disableBodyScroll(this.$el)
  },
  beforeDestroy() {
    this.visible = false;
    if (this.header) {
      this.setPadding(this.header);
    }
    document.removeEventListener('keydown', this.keyDownHandler);
    // enableBodyScroll(this.$el)
  },
  watch: {
    showModal: {
      handler(newValue) {
        if (newValue) {
          nextTick(() => this.openModal());
        } else {
          nextTick(() => this.closeModal());
        }
      },
    },
  },
  methods: {
    closeModal() {
      const modalCloseEvent = new CustomEvent('modalClose');
      window.dispatchEvent(modalCloseEvent);
      this.$emit('modalClose');
    },
    openModal() {
      this.visible = true;
      document.addEventListener('keydown', this.keyDownHandler, { passive: true });
    },
    keyDownHandler(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    },
    clickOutsideHandler(e) {
      const target = e.target;
      if (target.closest('.c-modal') === e.target) {
        this.closeModal();
      }
    },
    getScrollbarWidth() {
      const box = document.createElement('div');
      box.style.visibility = 'hidden';
      box.style.overflow = 'scroll'; // forcing scrollbar to appear
      document.body.appendChild(box);

      const scrollbarWidth = box.offsetWidth - box.clientWidth;
      document.body.removeChild(box);

      return scrollbarWidth;
    },
    setPadding(el) {
      const windowWidth = document.body.clientWidth;
      const scrollbarWidth = this.getScrollbarWidth();
      const padding = parseInt(window.getComputedStyle(el).paddingRight);
      if (windowWidth < 1920) {
        if (this.visible) {
          el.style.paddingRight = padding + scrollbarWidth + 'px';
        } else {
          el.style.paddingRight = '';
        }
      } else {
        if (this.visible) {
          el.style.maxWidth = el.offsetWidth + scrollbarWidth + 'px';
          el.style.paddingRight = padding + scrollbarWidth + 'px';
        } else {
          el.style.maxWidth = '';
          el.style.paddingRight = '';
        }
      }
    },
  },
});
